module.exports = __webpack_public_path__ + "static/media/Presentation1.35c5ba81.png";